import React from "react";


export const Title = (props) => {
    const {title, className, textA} = props;
    return (
        <div className="title">
            <p>
                {title}
                <a className={className}>{textA}</a>
            </p>
        </div>
    );
};
